module.exports = __webpack_public_path__ + "glyphicons-halflings-regular-f3a9a3b6.7ad17c6085dee9a33787.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/bootstrap/glyphicons-halflings-regular-f3a9a3b6.eot
// module id = 93
// module chunks = 2